import { useContext } from 'react'

import { MetadataContext } from 'context/MetadataContext'

export default function useMetadata(): MetadataContext {
  const metadataState = useContext(MetadataContext)
  return metadataState
}
